import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Applications from './pages/Applications';
import About from './pages/About';
import OurLogo from './pages/OurLogo';
import Contact from './pages/Contact';
import Forum from './pages/Forum';
import ForumTopic from './pages/ForumTopic';
import ForumGuidelines from './pages/ForumGuidelines';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyStatement from './pages/PrivacyStatement';
import CopyrightPolicy from './pages/CopyrightPolicy';
import Newsroom from './pages/Newsroom';
import WorkWithUs from './pages/WorkWithUs';  // Now "Who We Are" page
import FAQs from './pages/FAQs';
import Products from './pages/Products';
import Cart from './pages/Cart';
import CheckoutSuccess from './pages/CheckoutSuccess';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Admin from './pages/Admin';
import Booking from './pages/Booking';
import { trackVisit } from './utils/api';
import '@/App.css';

// Visitor tracking component
const VisitorTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page visit
    trackVisit({
      page: location.pathname,
      referrer: document.referrer,
      user_agent: navigator.userAgent
    }).catch(() => {}); // Silently fail if tracking fails
  }, [location.pathname]);
  
  return null;
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <VisitorTracker />
          <ScrollToTop />
          <div className="App">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/applications" element={<Applications />} />
                <Route path="/about" element={<About />} />
                <Route path="/logo" element={<OurLogo />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/forum" element={<Forum />} />
                <Route path="/forum/topic/:topicId" element={<ForumTopic />} />
                <Route path="/forum/guidelines" element={<ForumGuidelines />} />
                <Route path="/terms" element={<TermsOfUse />} />
                <Route path="/privacy" element={<PrivacyStatement />} />
                <Route path="/copyright" element={<CopyrightPolicy />} />
                <Route path="/newsroom" element={<Newsroom />} />
                <Route path="/who-we-are" element={<WorkWithUs />} />
                <Route path="/faqs" element={<FAQs />} />
                <Route path="/products/:category" element={<Products />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:id" element={<BlogPost />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/booking" element={<Booking />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <Toaster 
              position="top-center" 
              toastOptions={{
                style: {
                  background: '#FFFDF5',
                  color: '#1e293b',
                  border: '1px solid #e2e8f0',
                  marginTop: '80px'
                }
              }}
            />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;